<template>
    <div 
        class="chip text-uppercase d-inline-flex align-items-center gap-2" 
        :class="chipData.classes"
        :style="chipData.styles"
    >
        <b-icon v-if="chipData.icon" :icon="chipData.icon" class=""></b-icon>
        <span class="font-size-70">{{ chipData.label }}</span>
    </div>
</template>

<script>
export default {
    name: 'CompSingleMultipleChip',
    components: {},
    mixins: [],
    props: {
        value: {
            type: String,  // should be either 'single' or 'multiple'
            required: true,
        }
    },
    data() {
        return {
            singleData: {
                value: 'single',
                label: 'Single',
                icon: 'file',
                classes: ['chip-accent'],
                styles: {border: '1px solid var(--accent-200)'},
            },
            multipleData: {
                value: 'multiple',
                label: 'Multiple',
                icon: 'files',
                classes: ['chip-info'],
                styles: {border: '1px solid var(--info-200)'},
            },
            emptyData: {
                value: 'empty',
                label: '',
                icon: '',
                classes: ['d-none'],
                styles: {},
            },
        };
    },
    computed: {
        chipData() {
            switch (this.value) {
                case 'single':
                    return {...this.singleData};
                case 'multiple':
                    return {...this.multipleData};
                default:
                    return {...this.emptyData};
            }
        }
    }
}
</script>

<style>
</style>


